import { Investment } from '../types';

/** Capitaliza la primera letra de cada palabra; al dar espacio, la siguiente palabra también inicia en mayúscula */
export function capitalizeWords(value: string): string {
  if (!value || typeof value !== 'string') return value;
  return value
    .split(' ')
    .map((word) => (word ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() : word))
    .join(' ');
}

/** Valida formato de email */
export function isValidEmail(value: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());
}

/** Valida que solo contenga números (para teléfono nacional) */
export function isNumericPhone(value: string): boolean {
  return /^\d{0,10}$/.test(value.replace(/\s/g, ''));
}

/** Parsea valor de moneda: solo dígitos y un punto, max 2 decimales. Devuelve string válido para input */
export function formatCurrencyInput(value: string): string {
  const onlyNumbersAndDot = value.replace(/[^\d.]/g, '');
  const parts = onlyNumbersAndDot.split('.');
  if (parts.length > 2) {
    return parts[0] + '.' + parts.slice(1).join('');
  }
  if (parts.length === 2 && parts[1].length > 2) {
    return parts[0] + '.' + parts[1].slice(0, 2);
  }
  return onlyNumbersAndDot;
}

/** Convierte string de moneda a número */
export function parseCurrencyToNumber(value: string): number {
  const cleaned = value.replace(/[^\d.]/g, '');
  const num = parseFloat(cleaned);
  return isNaN(num) ? 0 : num;
}

/**
 * Valida que la suma de ownershipPct por propiedad no supere 100%
 */
export function validatePropertyOwnership(
  investments: Investment[],
  propertyId: string,
  newPct: number,
  excludeInvestmentId?: string
): { valid: boolean; currentTotal: number; error?: string } {
  const currentInvestments = investments.filter(
    inv => inv.propertyId === propertyId && 
           inv.status === 'active' &&
           inv.id !== excludeInvestmentId
  );
  
  const currentTotal = currentInvestments.reduce(
    (sum, inv) => sum + inv.ownershipPct, 
    0
  );
  
  const newTotal = currentTotal + newPct;
  
  if (newTotal > 100) {
    return {
      valid: false,
      currentTotal,
      error: `La suma de participación excede 100%. Actual: ${currentTotal}%, Intentando agregar: ${newPct}%`
    };
  }
  
  return { valid: true, currentTotal };
}

